import React, { useEffect, useState } from 'react';
import '../styles/MarketMarquee.css';

const Stocks = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const res = await fetch(
          'https://stocks.algobook.info/api/v1/stocks?tickers=AAPL,NVDA,MSFT,GOOGL,AMZN,TSLA,META,AMD,INTC,CRM,ADBE,ORCL,CSCO,SNAP,UBER,LYFT,SHOP,ROKU,SQ,PLTR,NFLX,DIS,BA,KO,PEP'
        );
        const data = await res.json();

        const formatted = data.map(stock => {
          const price = typeof stock.lastPrice === 'number' ? stock.lastPrice : null;
          const change = stock.lastClose
            ? ((stock.lastPrice - stock.lastClose) / stock.lastClose * 100).toFixed(2)
            : '0.00';

          return {
            name: stock.name || stock.ticker,
            ticker: stock.ticker,
            price,
            percentChange: change,
          };
        });

        setItems(formatted);
      } catch (err) {
        console.error('Error fetching stock data:', err);
      }
    };

    fetchStockData();
  }, []);

  const loopItems = [...items, ...items]; // duplicate for continuous scroll

  return (
    <div className="market-marquee-container">
      <div className="market-marquee">
        {loopItems.map((item, index) => (
          <div key={index} className="marquee-card">
            <div className="stock-name">
              {item.name}{' '}
              <span className={parseFloat(item.percentChange) >= 0 ? 'green' : 'red'}>
                ({item.percentChange}%)
              </span>
            </div>
            <div className="stock-price">
              {item.ticker} | {item.price !== null ? `$${item.price.toFixed(2)}` : 'N/A'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stocks;